import { Action } from '@ngrx/store';


export enum AdmCartoActionTypes {
  GET_ADM_CARTO = '[ADM_CARTO] GetCarto',
  SET_ADM_CARTO = '[ADM_CARTO] SetCarto',
  EDIT_ADM_CARTO = '[ADM_CARTO] EditCarto',
  DELETE_ADM_CARTO = '[ADM_CARTO] DeleteCarto',
  SUCESS_CARTO = '[ADM_CARTO] SuccessCarto',
  FAIL_CARTO = '[ADM_CARTO] FailCarto',
}

export class AdmGetCarto implements Action {
  readonly type = AdmCartoActionTypes.GET_ADM_CARTO;
  constructor() {}
}

export class AdmSetCarto implements Action {
  readonly type = AdmCartoActionTypes.SET_ADM_CARTO;
  constructor(public DatosCarto: any) {}
}
export class AdmEditCarto implements Action {
  readonly type = AdmCartoActionTypes.EDIT_ADM_CARTO;
  constructor(public DatosCarto: any) {}
}

export class AdmDeleteCarto implements Action {
  readonly type = AdmCartoActionTypes.DELETE_ADM_CARTO;
  constructor(public ObjDel: any) {}
}

export class AdmSuscessCarto implements Action {
  readonly type = AdmCartoActionTypes.SUCESS_CARTO;
  constructor(public Respuesta: any , public TipoR: string) {}
}

export class AdmFailCarto implements Action {
  readonly type = AdmCartoActionTypes.FAIL_CARTO;
  constructor(public Respuesta: any) {}
}


export type AdmCartoAcciones =
    | AdmGetCarto
    | AdmSetCarto
    | AdmEditCarto
    | AdmDeleteCarto
    | AdmSuscessCarto
    | AdmFailCarto;
